import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Modal } from 'react-bootstrap'
import { appGetAllDirectories } from '../../store/directories/directories'
import { matrimonialExportColumns } from '../../config/exportColumns/matrimonialExportColumns'
import { businessExportColumns } from '../../config/exportColumns/businessExportColumns.js'
import { jobExportColumns } from '../../config/exportColumns/jobExportColumns'
import ExportButton from '../../common/ExportButton'

const DirectoriesTabs = ({ hubDetails, sansthaDetails }) => {
	const dispatch = useDispatch()
	const [activeTab, setActiveTab] = useState('matrimonial')
	const [selectedItem, setSelectedItem] = useState(null)
	// console.log(selectedItem)
	const { directories } = useSelector(state => state.directoriesReducer)
	//console.log(directories);

	useEffect(() => {
		let params = {}
		if (activeTab === 'matrimonial') params = { matrimonialEnabled: true }
		if (activeTab === 'business') params = { businessDataEnabled: true }
		if (activeTab === 'job') params = { jobDataEnabled: true }

		// dispatch(appGetAllDirectories({ page: 1, limit: 1000, params }));
	}, [activeTab, dispatch])

	useEffect(() => {
		let params = { page: 1, limit: 1000 }

		if (hubDetails) params.hubId = hubDetails?._id
		if (sansthaDetails) params.sansthaId = sansthaDetails?._id

		if (activeTab === 'matrimonial') {
			params.matrimonialEnabled = true
		} else if (activeTab === 'business') {
			params.businessDataEnabled = true
		} else if (activeTab === 'job') {
			params.jobDataEnabled = true
		}

		dispatch(appGetAllDirectories(params))
	}, [dispatch, activeTab, hubDetails, sansthaDetails])

	const maskMobile = mobile => {
		if (!mobile) return ''
		if (mobile.length < 4) return mobile
		return mobile.slice(0, 2) + '******' + mobile.slice(-2)
	}

	const calculateAgeFromDOB = dob => {
		if (!dob) return ''

		const [day, month, year] = dob.split('-').map(Number)
		if (!day || !month || !year) return ''

		const birthDate = new Date(year, month - 1, day)
		const today = new Date()

		let age = today.getFullYear() - birthDate.getFullYear()
		const monthDiff = today.getMonth() - birthDate.getMonth()

		if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
			age--
		}

		return age
	}

	return (
		<div>
			<ul className="nav nav-tabs w-100">
				<li className="nav-item flex-fill text-center">
					<button
						className={`nav-link w-100 ${activeTab === 'matrimonial' ? 'active' : ''}`}
						onClick={() => setActiveTab('matrimonial')}
					>
						Matrimonial
					</button>
				</li>
				<li className="nav-item flex-fill text-center">
					<button
						className={`nav-link w-100 ${activeTab === 'business' ? 'active' : ''}`}
						onClick={() => setActiveTab('business')}
					>
						Business
					</button>
				</li>
				<li className="nav-item flex-fill text-center">
					<button
						className={`nav-link w-100 ${activeTab === 'job' ? 'active' : ''}`}
						onClick={() => setActiveTab('job')}
					>
						Job
					</button>
				</li>
			</ul>

			<div className="d-flex justify-content-end mt-3 mr-3">
				{activeTab === 'matrimonial' && (
					<ExportButton
						fetchAction={params =>
							dispatch(
								appGetAllDirectories({
									...params,
									page: 1,
									limit: 100000,
									matrimonialEnabled: true,
									hubId: hubDetails?._id,
									sansthaId: sansthaDetails?._id,
									loading: false,
								}),
							)
						}
						columns={matrimonialExportColumns}
						fileName="Matrimonial_List"
						sheetName="Matrimonial"
						buttonText="Export Matrimonial"
						buttonClass="btn btn-success"
					/>
				)}

				{activeTab === 'business' && (
					<ExportButton
						fetchAction={params =>
							dispatch(
								appGetAllDirectories({
									...params,
									page: 1,
									limit: 100000,
									businessDataEnabled: true,
									hubId: hubDetails?._id,
									sansthaId: sansthaDetails?._id,
									loading: false,
								}),
							)
						}
						columns={businessExportColumns}
						fileName="Business_List"
						sheetName="Business"
						buttonText="Export Business"
						buttonClass="btn btn-success"
					/>
				)}

				{activeTab === 'job' && (
					<ExportButton
						fetchAction={params =>
							dispatch(
								appGetAllDirectories({
									...params,
									page: 1,
									limit: 100000,
									jobDataEnabled: true,
									hubId: hubDetails?._id,
									sansthaId: sansthaDetails?._id,
									loading: false,
								}),
							)
						}
						columns={jobExportColumns}
						fileName="Job_List"
						sheetName="Job"
						buttonText="Export Job"
						buttonClass="btn btn-success"
					/>
				)}
			</div>

			<div className="row mt-3">
				{directories?.data?.map(item => (
					<div key={item._id} className="col-md-4 mb-3">
						<div
							className="card text-center shadow-sm cursor-pointer"
							onClick={() => setSelectedItem(item)}
						>
							<img
								src={item?.profilePic || item?.businessLogo || '/img/user.jpg'}
								alt={item?.firstName}
								className="card-img-top rounded-circle mx-auto mt-3"
								style={{ width: '80px', height: '80px', objectFit: 'cover' }}
							/>
							<div className="card-body">
								<h6 className="card-title">
									{item?.firstName} {item?.lastName}
								</h6>
								<p className="text-muted mb-0">{item?.mobile}</p>
							</div>
						</div>
					</div>
				))}
			</div>

			<Modal show={!!selectedItem} onHide={() => setSelectedItem(null)} size="lg" centered>
				<Modal.Header closeButton>
					<Modal.Title>
						{selectedItem?.firstName} {selectedItem?.lastName}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<h5 className="mb-3 text-success fw-bold">User Info</h5>
					<div className="d-flex align-items-center mb-3">
						<img
							src={selectedItem?.profilePic || selectedItem?.businessLogo || '/img/user.jpg'}
							alt="Profile"
							style={{
								width: 60,
								height: 60,
								borderRadius: '50%',
								marginRight: 15,
							}}
						/>
						<div>
							<h6 className="mb-0">
								{selectedItem?.firstName} {selectedItem?.lastName}
							</h6>
							<p className="mb-0 text-muted">{selectedItem?.mobile}</p>
						</div>
					</div>

					<hr />

					{activeTab === 'matrimonial' && (
						<>
							<h5 className="mb-3 text-success fw-bold">Matrimonial Info</h5>
							<p>
								<strong>Education :</strong> {selectedItem?.education || '------'}
							</p>
							<p>
								<strong>Profession :</strong> {selectedItem?.profession || '------'}
							</p>
							<p>
								<strong>Date of Birth :</strong> {selectedItem?.dob || '------'}
							</p>
							<p>
								<strong>Age :</strong>{' '}
								{selectedItem?.age
									? `${selectedItem?.age} Years`
									: selectedItem?.dob
									? `${calculateAgeFromDOB(selectedItem?.dob)} Years`
									: '------'}
							</p>
							<p>
								<strong>Height :</strong> {selectedItem?.height || '------'}
							</p>
							<p>
								<strong>Goutra :</strong> {selectedItem?.goutra || '------'}
							</p>
							<p>
								<strong>Income Band :</strong>{' '}
								{selectedItem?.incomeBand ? (
									<>
										{selectedItem.incomeBand} <span className="text-muted">(Lacs Per Annum)</span>
									</>
								) : (
									'------'
								)}
							</p>
							<p>
								<strong>Native Address :</strong>{' '}
								{`${selectedItem?.nativePlaceAddress || ''}, ${selectedItem?.nativeArea ||
									''}, ${selectedItem?.nativeBlock || ''}, ${selectedItem?.nativeDistrict ||
									''}, ${selectedItem?.nativeState || ''}, ${selectedItem?.nativePlacePincode ||
									''}`}
							</p>
						</>
					)}

					{activeTab === 'business' && (
						<>
							<h5 className="mb-3 text-success fw-bold">Business Info</h5>
							<p>
								<strong>Firm Name :</strong> {selectedItem?.businessFirmName || '------'}
							</p>
							<p>
								<strong>Industry Type :</strong> {selectedItem?.businessIndustry || '------'}
							</p>
							<p>
								<strong>Services :</strong> {selectedItem?.businessServices || '------'}
							</p>
							<p>
								<strong>Address :</strong>{' '}
								{`${selectedItem?.businessNativePlaceAddress ||
									''}, ${selectedItem?.businessNativeArea ||
									''}, ${selectedItem?.businessNativeBlock ||
									''}, ${selectedItem?.businessNativeDistrict ||
									''}, ${selectedItem?.businessNativeState ||
									''}, ${selectedItem?.businessNativePlacePincode || ''}`}
							</p>
							<p>
								<strong>Category :</strong> {selectedItem?.businessCategory || '------'}
							</p>
							<p>
								<strong>Contact Number :</strong> {selectedItem?.businessContactNo || '------'}
							</p>
							<p>
								<strong>Webisite/UP :</strong> {selectedItem?.businessUPIWebsite || '------'}
							</p>
						</>
					)}

					{activeTab === 'job' && (
						<>
							<h5 className="mb-3 text-success fw-bold">Job Info</h5>
							<p>
								<strong>Role :</strong> {selectedItem?.jobRole || '------'}
							</p>
							<p>
								<strong>Education :</strong> {selectedItem?.education || '------'}
							</p>
							<p>
								<strong>Skill :</strong> {selectedItem?.jobSkill || '------'}
							</p>
							<p>
								<strong>Experience :</strong> {selectedItem?.jobExperience || '------'}
							</p>
							<p>
								<strong>Salary Band :</strong> {selectedItem?.jobSalaryBand || '------'}
							</p>
							<p>
								<strong>Preferred Location :</strong>{' '}
								{selectedItem?.jobPreferredLocation || '------'}
							</p>
						</>
					)}

					<div className="text-center mt-4">
						<button
							onClick={() => setSelectedItem(null)}
							style={{
								borderRadius: '50%',
								width: 50,
								height: 50,
								fontSize: 22,
								padding: 0,
							}}
						>
							✕
						</button>
					</div>
				</Modal.Body>
			</Modal>
		</div>
	)
}

export default DirectoriesTabs
